// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetActiveTypesByBboxRequest,
  TGetActiveTypesByBboxModel,
  IMappers,
  TGetActiveTypesByBboxResponse,
  TGetActiveTypesByBboxResponse_1,
  TGetActiveTypesByBboxResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TGetActiveTypesByBboxModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'infrastructure-caching',
  pathApi: '/v1/get-active-types-by-bbox/',
  interserviceAuthEnabled: true,
} as TGetActiveTypesByBboxModel;

export function createGetActiveTypesByBboxModel(parameters: IGetActiveTypesByBboxRequest): TGetActiveTypesByBboxModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetActiveTypesByBboxOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetActiveTypesByBboxRequest;
}

export async function fetchGetActiveTypesByBbox<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetActiveTypesByBboxOptions<TResponse200, TResponse400>): Promise<
  TGetActiveTypesByBboxResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetActiveTypesByBboxModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetActiveTypesByBboxResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetActiveTypesByBboxResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetActiveTypesByBboxResponse;
}
